<div class="zip-row-input" [ngClass]="{ 'is-error': validationService.errorResponse.code === 4 }">
  <div class="row-input-wrapper">
    <div class="input-label">
      <span> Your friend's email </span>
    </div>
    <div class="input-wrapper">
      <input
        [id]="zipYiElement.GiftingRecipientEmail"
        [(ngModel)]="validationService.friendForm.friendEmail"
        type="text"
        (blur)="
          checkFieldEmail($event); selectOptionService.handleBlurInput($event); validateFormFriend()
        "
        (input)="validateFormFriend()"
        (focus)="selectOptionService.handleFocusInput($event)"
        #inputFriendEmail
      />
    </div>
  </div>
  <div class="row-input-error">
    <span class="is-error" *ngIf="validationService.errorResponse.code !== 4"
      >Please enter a valid email address</span
    >
    <span class="is-error" *ngIf="validationService.errorResponse.code === 4">
      {{ validationService.errorResponse.message }}
    </span>
  </div>
</div>
<div class="zip-row-input" [ngClass]="{ 'is-error': validationService.errorResponse.code === 3 }">
  <div class="row-input-wrapper">
    <div class="input-label">
      <span> Confirm email </span>
    </div>
    <div class="input-wrapper">
      <input
        [id]="zipYiElement.GiftingRecipientEmailConfirm"
        [(ngModel)]="validationService.friendForm.friendEmailConfirm"
        type="text"
        (blur)="
          checkFieldConfirmEmail($event);
          selectOptionService.handleBlurInput($event);
          validateFormFriend()
        "
        (input)="validateFormFriend()"
        (focus)="selectOptionService.handleFocusInput($event)"
        #inputFriendEmailConfirm
      />
    </div>
  </div>
  <div class="row-input-error">
    <span class="is-error" *ngIf="validationService.errorResponse.code !== 3"
      >The email address doesn’t match</span
    >
    <span class="is-error" *ngIf="validationService.errorResponse.code === 3">
      {{ validationService.errorResponse.message }}
    </span>
  </div>
</div>
<div class="zip-row-input">
  <div class="row-input-wrapper">
    <div class="input-label">
      <span> Your friend's name </span>
    </div>
    <div class="input-wrapper">
      <input
        [id]="zipYiElement.GiftingRecipientName"
        [(ngModel)]="validationService.friendForm.friendName"
        type="text"
        (blur)="
          checkFieldName($event); selectOptionService.handleBlurInput($event); validateFormFriend()
        "
        (input)="validateFormFriend()"
        (focus)="selectOptionService.handleFocusInput($event)"
        #inputFriendName
      />
    </div>
  </div>
  <div class="row-input-error">
    <span
      class="is-error"
      *ngIf="!validationService.checkNull(validationService.friendForm.friendName)"
      >Please enter your friend’s name</span
    >
    <span
      class="is-error"
      *ngIf="!validationService.checkLength(validationService.friendForm.friendName, 50)"
      >Sorry this must be less than 50 characters</span
    >
    <span
      class="is-error"
      *ngIf="!validationService.checkValidName(validationService.friendForm.friendName)"
      >Please enter a valid name</span
    >
  </div>
</div>
<div
  class="zip-row-input row-rl"
  [ngClass]="{
    'is-error':
      validationService.errorResponse.code === 5 ||
      !validationService.checkLength(validationService.friendForm.friendNote, 100)
  }"
>
  <div class="row-input-wrapper no-icon-error">
    <div class="input-label">
      <span> Send a note </span>
    </div>
    <div class="input-wrapper row-rl">
      <div class="textarea-wrapper">
        <textarea
          [id]="zipYiElement.GiftingNote"
          [(ngModel)]="validationService.friendForm.friendNote"
          (blur)="
            checkFieldNote($event);
            selectOptionService.handleBlurInput($event);
            validateFormFriend()
          "
          (input)="validateFormFriend()"
          (focus)="selectOptionService.handleFocusInput($event)"
          #inputFriendNote
        ></textarea>
      </div>
      <div class="btn-gif" *ngIf="isGifEnabled" (click)="giphyService.showHideGiphy()"></div>
    </div>
  </div>
  <div class="row-hint">
    <div class="row-input-error">
      <span
        class="is-error"
        *ngIf="
          validationService.errorResponse.code !== 5 &&
          validationService.checkLength(validationService.friendForm.friendNote, 100)
        "
        >Please enter a simple message</span
      >
      <span
        class="is-error"
        *ngIf="
          validationService.errorResponse.code !== 5 &&
          !validationService.checkLength(validationService.friendForm.friendNote, 100)
        "
      >
        Message exceeds allowed characters of 100
      </span>
      <span class="is-error" *ngIf="validationService.errorResponse.code === 5">
        {{ validationService.errorResponse.message }}
      </span>
    </div>
    <div class="input-hint">Maximum 100 characters</div>
  </div>
</div>
<div class="giphy-contain row-rl">
  <app-giphy></app-giphy>
</div>
<div class="zip-row-input spacing-bottom-23">
  <div class="row-input-wrapper" (click)="doScheduledGifting()">
    <div class="radio-input">
      <div class="radio-input-label">Send on a specific date</div>
      <div
        [ngClass]="{
          'is-active': isScheduledGifting
        }"
        class="radio-input-button"
        [id]="zipYiElement.GiftingScheduleToggle"
      >
        <div class="radio-bar">
          <div class="radio-circle"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="zip-row-input is-inputed" *ngIf="isScheduledGifting">
  <div class="row-input-wrapper datepicker-contain">
    <div class="input-wrapper">
      <app-date-picker
        label="Date of sending"
        hint="To be delivered at 8:00 am in your local time"
        [(value)]="validationService.deliveryDate"
        [dateFilter]="dateFilter"
      ></app-date-picker>
    </div>
  </div>
</div>
<div class="zip-row-input">
  <div class="buy-buttons">
    <button
      [id]="zipYiElement.GiftingConfirmBtn"
      class="button-blue-friend button-small"
      [ngClass]="crossDomainCssClass"
      (click)="confirmBuyForFriend()"
      [ngClass]="{
        'is-disable':
          !isCardAvailability ||
          !validationService.isValid ||
          selectOptionService.dataSelected === '' ||
          !selectOptionService.isValidCustomAmount ||
          !isValidScheduledGifting
      }"
      [disabled]="
        !isCardAvailability ||
        !validationService.isValid ||
        selectOptionService.dataSelected === '' ||
        !selectOptionService.isValidCustomAmount ||
        !isValidScheduledGifting
      "
    >
      Confirm and checkout
    </button>
  </div>
</div>
